<template>
    <v-content>

        <v-container
                class="fill-height"
                fluid
        >
            <v-row
                    align="center"
                    justify="center"
            >
                <div>
                    <v-img :max-width="maxWidth" v-if="marque === true" contain center :src="logo" alt="Logo magasin"></v-img>
                    <v-img v-else :max-width="maxWidth" contain center :src="require('../assets/image/logo-webtroc.png')" alt="Web-Troc"></v-img>
                </div>
            </v-row>
            <v-row
                    align="center"
                    justify="center"
            >
                <v-col
                        cols="12"
                        sm="8"
                        md="6"
                >
                    <v-card class="elevation-12">
                        <v-toolbar
                                color="primary"
                                dark
                                flat
                        >
                            <v-toolbar-title>Application déposant</v-toolbar-title>

                        </v-toolbar>
                        <v-card-text>
                            <v-form>
                                <p v-if="errorMessage" class="error text-center">{{ errorMessage }}</p>
                                <v-select
                                        label="Choisissez votre magasin"
                                        outlined
                                        v-if="marque === false"
                                        :items="depotVentes"
                                        :item-value="'id'"
                                        :item-text="'raisonSociale'"
                                        v-model="depotVente"
                                >

                                </v-select>
                                <v-text-field
                                        label="Entrez votre adresse email"
                                        name="login"
                                        prepend-inner-icon="account_circle"
                                        type="text"
                                        v-model="email"
                                ></v-text-field>

                                <v-text-field
                                        id="password"
                                        label="Entrez votre ID déposant"
                                        name="deposant"
                                        prepend-inner-icon="lock"
                                        type="text"
                                        v-model="idSoft"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="loadingForm === false" block color="primary" @click="submit()">Se connecter</v-btn>
                          <div v-else>
                            <v-progress-circular indeterminate></v-progress-circular>
                            <span>Connexion en cours...</span>
                          </div>

                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>

</template>

<script>
  export default {
    data () {
      return {
        email: '',
        idSoft: '',
        depotVente: null,
        width: window.outerWidth
      }
    },

    props: {
      errorMessage: {
        type: String,
        default: ''
      },
      depotVentes: {
      },
      loadingForm: {
      },
      loadingList: {
      },
      marque: {
      },
      logo: {},
      logoMobile: {}
    },

    methods: {
      submit () {
        this.$emit('submit', {
          email: this.email,
          idSoft: this.idSoft,
          depotVente: this.depotVente
        })
      }
    },
    computed: {
      currentHost(){
        return location.hostname;
      },
      maxWidth(){
        return this.width / 2;
      }
    }
  }
</script>

<style scoped>

</style>
